export const customerPasswordRegExp = /(?=.*\d)(?=.*[A-Za-z])(?=.*[!#$%&*?@^_-])(?!.*\s).{8,}/;
export const invalidPasswordMsg = 'Das Passwort muss mindestens 8 Zeichen lang sein und folgende Angaben enthalten: \n 1 Großbuchstabe, 1 Kleinbuchstabe, 1 Zahl und 1 Sonderzeichen (z. B. , . _ & ? usw.)';
